import { all } from 'redux-saga/effects';

import consultaTransferenciaMunicipalSaga from './consultaTransferenciaMunicipal/saga';
import gerarRenachSaga from './gerarRenach/saga';

export default all([consultaTransferenciaMunicipalSaga, gerarRenachSaga]);
